export const toISODate = (date) => {
  if (!date) return '';
  const instance = date instanceof Date ? date : new Date(date);
  return instance.toISOString().split('T')[0];
};

export const createDefaultOrderForm = () => {
  const today = new Date();
  return {
    emission_date: toISODate(today),
    uuid_legal_entity: '',
    applied_to_description: '',
    observations: '',
    status: 'pending',
    total_amount: '',
    cost_behavior: '',
    cost_nature: '',
    cost_traceability: '',
    cost_area: '',
    payment_method: '',
    currency: 'ARS',
    exchange_rate_to_ars: '',
    total_amount_ars: '',
    net_payable_amount: '',
    net_payable_amount_ars: '',
    uuid_cash_account: '',
  };
};

export const parseAmountInput = (rawValue) => {
  if (rawValue === null || rawValue === undefined) return null;
  if (typeof rawValue === 'number') {
    return Number.isNaN(rawValue) ? null : rawValue;
  }

  const trimmed = String(rawValue).trim();
  if (!trimmed) return null;

  let normalized = trimmed.replace(/\s+/g, '');
  normalized = normalized.replace(/[^0-9.,+-]/g, '');
  const hasComma = normalized.includes(',');
  const hasDot = normalized.includes('.');

  if (hasComma && hasDot) {
    normalized = normalized.replace(/\./g, '').replace(',', '.');
  } else if (hasComma) {
    normalized = normalized.replace(',', '.');
  } else {
    const dotCount = (normalized.match(/\./g) || []).length;
    if (dotCount > 1) {
      normalized = normalized.replace(/\./g, '');
    }
  }

  const parsed = Number.parseFloat(normalized);
  return Number.isNaN(parsed) ? null : parsed;
};

export const createMovementDraft = (emissionDate, conceptName = '', conceptUuid = '') => ({
  fund_account_id: '',
  uuid_bank_account: '',
  uuid_cash_account: '',
  uuid_movement_type: '',
  emission_date: emissionDate,
  due_date: '',
  amount: '',
  amountSign: -1,
  voucher_number: '',
  concept: conceptName,
  uuid_movement_concept: conceptUuid,
  display_in_book: true,
  is_reconciled: false,
});

export const createTempId = () => `temp-${Math.random().toString(36).slice(2, 11)}`;

export const getMovementKey = (movement) => movement.uuid ?? movement.tempId;

export const calculateMovementsTotal = (movements = []) =>
  Math.abs(
    movements.reduce((total, movement) => {
      const numericAmount = parseAmountInput(movement.amount);
      if (numericAmount === null) {
        return total;
      }
      const sign =
        movement.amountSign != null
          ? movement.amountSign
          : numericAmount < 0
          ? -1
          : 1;
      return total + numericAmount * sign;
    }, 0),
  );

export const buildMovementPayload = (movement, fallbackEmissionDate) => ({
  uuid: movement.uuid || undefined,
  uuid_bank_account: movement.uuid_bank_account || null,
  uuid_cash_account: movement.uuid_cash_account || null,
  uuid_movement_type: movement.uuid_movement_type,
  emission_date: new Date(movement.emission_date || fallbackEmissionDate).toISOString(),
  due_date: movement.due_date ? new Date(movement.due_date).toISOString() : null,
  amount: (() => {
    const numericAmount = parseAmountInput(movement.amount);
    if (numericAmount === null) return 0;
    const sign =
      movement.amountSign != null
        ? movement.amountSign
        : numericAmount < 0
        ? -1
        : 1;
    return Number.parseFloat((numericAmount * sign).toFixed(2));
  })(),
  concept: movement.concept?.trim() || null,
  uuid_movement_concept: movement.uuid_movement_concept || null,
  voucher_number: movement.voucher_number?.trim() || null,
  uuid_legal_entity: movement.uuid_legal_entity || null,
  cost_behavior: movement.cost_behavior || null,
  cost_nature: movement.cost_nature || movement.cost_traceability || null,
  cost_traceability: movement.cost_nature || movement.cost_traceability || null,
  cost_area: movement.cost_area || null,
  payment_method: movement.payment_method || null,
  currency: movement.currency || 'ARS',
  exchange_rate_to_ars: movement.exchange_rate_to_ars || null,
  display_in_book: movement.display_in_book !== false,
});
